import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M8 13c-1.018 0-1.963-.309-2.753-.833l6.92-6.92C12.691 6.038 13 6.982 13 8c0 2.757-2.243 5-5 5M8 3c1.018 0 1.963.309 2.753.833l-6.92 6.92C3.309 9.962 3 9.018 3 8c0-2.757 2.243-5 5-5m0-2C4.141 1 1 4.141 1 8s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M12 20c-1.846 0-3.542-.635-4.897-1.688L18.312 7.103C19.366 8.457 20 10.154 20 12c0 4.411-3.589 8-8 8m-8-8c0-4.411 3.589-8 8-8 1.846 0 3.542.635 4.897 1.688L5.688 16.897C4.634 15.543 4 13.846 4 12m8-10C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2"
        />
      </g>
    </svg>
  ),
};
